/* ==========================================================
   PhonelyStore — Main JS
   Shopify-connected: products loaded via AJAX Collection API
   Supports multiple collections per tier + price range filter
   ========================================================== */

/* ── SVG inline reusables ── */
const SVG = {
  ac:     `<svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="#d6d3d1" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="8" rx="2"/><path d="M7 14v4"/><path d="M17 14v4"/><path d="M6 10h.01"/><path d="M10 10h.01"/><line x1="12" y1="2" x2="12" y2="6"/><path d="M8 2h8"/></svg>`,
  wind:   `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"/></svg>`,
  bolt:   `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>`,
  vol:    `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>`,
  cart:   `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`,
  search: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d6d3d1" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>`,
};

const ICON_SVGS = {
  dollar:  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ea580c" stroke-width="1.8" stroke-linecap="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>`,
  sliders: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="1.8" stroke-linecap="round"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>`,
  star:    `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="1.8" stroke-linecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`,
  bolt:    `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="1.8" stroke-linecap="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>`,
};

const FILTER_DEFS = {
  iphone16:    [{ k:'all', l:'Tous' }, { k:'base', l:'iPhone 16' }, { k:'pro', l:'Pro' }, { k:'promax', l:'Pro Max' }],
  iphone17:    [{ k:'all', l:'Tous' }, { k:'base', l:'iPhone 17' }, { k:'air', l:'Air' }, { k:'pro', l:'Pro' }, { k:'promax', l:'Pro Max' }],
  iphone18:    [{ k:'all', l:'Tous' }, { k:'pro', l:'Pro' }, { k:'promax', l:'Pro Max' }],
  duo:         [{ k:'all', l:'Tous' }],
  montres:     [{ k:'all', l:'Tous' }, { k:'series12', l:'Series 12' }, { k:'ultra', l:'Ultra 4' }],
  accessoires: [{ k:'all', l:'Tous' }, { k:'airpods', l:'AirPods' }, { k:'chargeur', l:'Chargeurs' }],
};

/* ── Utilitaires ── */
function norm(s)  { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
function pct(p,c) { return Math.round((1 - p / c) * 100); }
function formatMoney(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '€'; }

function hl(text, q) {
  if (!q) return text;
  return text.replace(new RegExp(`(${q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')})`, 'gi'), '<mark>$1</mark>');
}

/* ── Étoiles ── */
function renderStars(count, total = 5) {
  let out = '<div style="display:flex;gap:3px;align-items:center">';
  for (let i = 1; i <= total; i++) {
    const f = i <= count;
    out += `<svg width="13" height="13" viewBox="0 0 24 24" fill="${f?'#f59e0b':'none'}" stroke="${f?'#f59e0b':'#cbd5e1'}" stroke-width="1.8" stroke-linecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;
  }
  return out + '</div>';
}

/* ══════════════════════════════════════════════════════
   CACHE global — partagé entre tiers et recherche
══════════════════════════════════════════════════════ */
const collectionCache = {}; // handle → produits normalisés

/* Charge UNE collection Shopify (mise en cache) */
async function fetchCollection(handle) {
  if (collectionCache[handle]) return collectionCache[handle];
  try {
    const res  = await fetch(`/collections/${handle}/products.json?limit=250`);
    if (!res.ok) return [];
    const data = await res.json();
    const products = (data.products || []).map(normalizeShopifyProduct);
    collectionCache[handle] = products;
    return products;
  } catch { return []; }
}

/* Charge PLUSIEURS collections, déduplique par handle, filtre par prix */
async function fetchTierProducts(collections, priceMin, priceMax) {
  const results = await Promise.all(collections.map(fetchCollection));
  const seen    = new Set();
  const merged  = [];
  for (const list of results) {
    for (const p of list) {
      if (seen.has(p.id)) continue;
      seen.add(p.id);
      // Filtre fourchette de prix
      if (priceMin !== null && p.price < priceMin) continue;
      if (priceMax !== null && p.price > priceMax) continue;
      merged.push(p);
    }
  }
  // Trier par prix croissant
  return merged.sort((a, b) => a.price - b.price);
}

/* Redimensionne une URL image Shopify CDN */
function shopifyImgUrl(src, size) {
  if (!src) return '';
  // Shopify CDN : insérer _SIZExSIZE avant l'extension (avant le ?)
  return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, `_${size}x${size}$1$3`);
}

/* Normalise un produit Shopify en objet interne */
function normalizeShopifyProduct(p) {
  const tags     = p.tags || [];
  const chipTag  = tags.find(t => t.toLowerCase().startsWith('puce-')) || '–';
  const rawImg   = p.images?.[0]?.src || '';
  return {
    id:        p.handle,
    name:      p.title,
    vendor:    p.vendor,
    price:     p.variants?.[0]?.price             ? parseFloat(p.variants[0].price)             : 0,
    compare:   p.variants?.[0]?.compare_at_price  ? parseFloat(p.variants[0].compare_at_price)  : 0,
    url:       `/products/${p.handle}`,
    img:       shopifyImgUrl(rawImg, 600),
    img2x:     shopifyImgUrl(rawImg, 1200),
    variantId: p.variants?.[0]?.id,
    chip:      chipTag,
    tags:      tags.filter(t => !t.toLowerCase().startsWith('puce-') && !t.toLowerCase().startsWith('couleur-')).slice(0, 3),
    desc:      p.body_html ? p.body_html.replace(/<[^>]+>/g, '').trim().slice(0, 220) : '',
  };
}

/* ══════════════════════════════════════════════════════
   MODAL
══════════════════════════════════════════════════════ */
let currentTier     = null;
let currentFilter   = 'all';
let currentProducts = [];

function openModal(tierKey) {
  currentTier   = tierKey;
  currentFilter = 'all';

  const cfg = (window.TIER_COLLECTIONS || {})[tierKey];
  if (!cfg) { console.warn('Tier non trouvé :', tierKey); return; }

  /* En-tête */
  const iconEl = document.getElementById('modalIcon');
  iconEl.style.background = cfg.colorBg;
  iconEl.innerHTML = ICON_SVGS[cfg.icon] || '';
  document.getElementById('modalTitle').textContent    = cfg.label;
  document.getElementById('modalSubtitle').textContent = cfg.sub;

  /* Filtres */
  renderFilters(tierKey);

  /* Ouvrir */
  document.getElementById('modalOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';

  /* Charger les produits depuis toutes les collections du tier */
  loadTierProducts(cfg);
}

async function loadTierProducts(cfg) {
  const grid = document.getElementById('modalGrid');
  grid.innerHTML = '<div class="modal-loading">Chargement des produits…</div>';

  const collections = Array.isArray(cfg.collections) ? cfg.collections : [cfg.collection].filter(Boolean);
  const priceMin    = cfg.priceMin != null ? cfg.priceMin : null;
  const priceMax    = cfg.priceMax != null ? cfg.priceMax : null;

  currentProducts = await fetchTierProducts(collections, priceMin, priceMax);

  if (!currentProducts.length) {
    grid.innerHTML = `<div class="modal-empty" style="grid-column:1/-1">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <p>Aucun produit trouvé.<br><small style="color:#94a3b8">Vérifiez que vos collections Shopify contiennent des produits publiés.</small></p>
    </div>`;
    return;
  }
  renderModalGrid();
}

function matchFilter(p, key) {
  if (key === 'all') return true;
  const name = p.name.toLowerCase();
  if (key === 'promax')   return name.includes('pro max');
  if (key === 'pro')      return name.includes('pro') && !name.includes('pro max');
  if (key === 'air')      return name.includes('air');
  if (key === 'base')     return !name.includes('pro') && !name.includes('air');
  if (key === 'airpods')  return name.includes('airpods');
  if (key === 'chargeur') return name.includes('chargeur') || name.includes('adaptateur');
  if (key === 'series12') return name.includes('series 12');
  if (key === 'ultra')    return name.includes('ultra');
  return true;
}

function renderFilters(tierKey) {
  const defs = FILTER_DEFS[tierKey] || [{ k: 'all', l: 'Tous' }];
  const el   = document.getElementById('modalFilters');
  el.innerHTML = defs.map(f =>
    `<button class="filter-btn${f.k === 'all' ? ' active' : ''}" data-filter="${f.k}">${f.l}</button>`
  ).join('');
  el.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      el.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      currentFilter = btn.dataset.filter;
      renderModalGrid();
    });
  });
}

function renderModalGrid() {
  const filtered = currentProducts.filter(p => matchFilter(p, currentFilter));
  const grid     = document.getElementById('modalGrid');

  if (!filtered.length) {
    grid.innerHTML = `<div class="modal-empty" style="grid-column:1/-1">
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <p>Aucun produit pour ce filtre.</p>
    </div>`;
    return;
  }
  grid.innerHTML = filtered.map(renderProductCard).join('');
  bindCartButtons(grid);
  addRipple(grid);
}

function renderProductCard(p) {
  const disc      = p.compare > p.price ? pct(p.price, p.compare) : 0;
  const discBadge = disc > 0 ? `<div class="mc-disc">-${disc}%</div>` : '';
  const imgHtml   = p.img
    ? `<img src="${p.img}" srcset="${p.img} 1x, ${p.img2x} 2x" alt="${p.name}" loading="lazy" style="width:100%;height:100%;object-fit:cover"/>`
    : SVG.ac;

  return `
    <a href="${p.url}" class="mc" style="text-decoration:none;color:inherit;display:flex;flex-direction:column">
      <div class="mc-thumb">
        ${imgHtml}${discBadge}
        <div class="mc-tags">${p.tags.map(t => `<span class="mc-tag">${t}</span>`).join('')}</div>
      </div>
      <div class="mc-body">
        <div class="mc-vendor">${p.vendor}</div>
        <div class="mc-name">${p.name}</div>
        <div class="mc-pricing">
          <span class="mc-price">${formatMoney(p.price * 100)}</span>
          ${p.compare > p.price
            ? `<span class="mc-compare">${formatMoney(p.compare * 100)}</span><span class="mc-saving">-${disc}%</span>`
            : ''}
        </div>
        <div class="mc-specs">
          ${p.chip !== '–' ? `<span class="mc-spec">${SVG.bolt} ${p.chip.replace('puce-','').toUpperCase()}</span>` : ''}
        </div>
        <div class="mc-desc">${p.desc}</div>
        <div class="mc-actions">
          <button class="mc-btn-add" data-variant-id="${p.variantId}" type="button"
                  onclick="event.stopPropagation();event.preventDefault()">
            ${SVG.cart} Ajouter au panier
          </button>
        </div>
      </div>
    </a>`;
}

/* ══════════════════════════════════════════════════════
   PANIER — AJAX add to cart
══════════════════════════════════════════════════════ */
function bindCartButtons(root) {
  (root || document).querySelectorAll('[data-variant-id]').forEach(btn => {
    if (btn._cartBound) return;
    btn._cartBound = true;
    btn.addEventListener('click', async () => {
      const id = btn.dataset.variantId;
      if (!id) return;
      const orig  = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Ajout…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity: 1 }),
        });
        if (!res.ok) throw new Error();
        btn.innerHTML = 'Ajouté !';
        updateCartCount();
        setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; }, 2000);
      } catch {
        btn.innerHTML = 'Erreur';
        setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; }, 2000);
      }
    });
  });
}

async function updateCartCount() {
  try {
    const cart  = await fetch('/cart.js').then(r => r.json());
    const badge = document.querySelector('.cart-count');
    if (badge) { badge.textContent = cart.item_count; }
    else if (cart.item_count > 0) {
      const btn  = document.querySelector('.btn-cart');
      if (btn) {
        const s = document.createElement('span');
        s.className = 'cart-count';
        s.textContent = cart.item_count;
        btn.appendChild(s);
      }
    }
  } catch { /* silence */ }
}

document.addEventListener('DOMContentLoaded', () => bindCartButtons(document));

/* ══════════════════════════════════════════════════════
   FERMETURE MODAL
══════════════════════════════════════════════════════ */
function closeModal() {
  document.getElementById('modalOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('modalClose')?.addEventListener('click', closeModal);
  document.getElementById('modalOverlay')?.addEventListener('click', e => {
    if (e.target === e.currentTarget) closeModal();
  });
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

/* ══════════════════════════════════════════════════════
   RECHERCHE — charge toutes les collections en parallèle
══════════════════════════════════════════════════════ */
let allSearchProducts = [];

async function loadAllProductsForSearch() {
  const tiers = window.TIER_COLLECTIONS || {};
  // Collecte tous les handles uniques de toutes les gammes
  const allHandles = [...new Set(
    Object.entries(tiers).flatMap(([, cfg]) =>
      Array.isArray(cfg.collections) ? cfg.collections : [cfg.collection].filter(Boolean)
    )
  )];
  const results = await Promise.all(allHandles.map(h => fetchCollection(h)));
  const seen    = new Set();
  allSearchProducts = [];
  for (const [i, list] of results.entries()) {
    for (const p of list) {
      if (seen.has(p.id)) continue;
      seen.add(p.id);
      // Trouver à quelle gamme appartient ce produit
      const tier = Object.entries(tiers).find(([, cfg]) => {
        const cols = Array.isArray(cfg.collections) ? cfg.collections : [cfg.collection];
        return cols.includes(allHandles[i]) &&
          (cfg.priceMin == null || p.price >= cfg.priceMin) &&
          (cfg.priceMax == null || p.price <= cfg.priceMax);
      });
      allSearchProducts.push({ ...p, tier: tier?.[0] || '', tierLabel: tier?.[1]?.label || '' });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  loadAllProductsForSearch();

  const input    = document.getElementById('searchInput');
  const dropdown = document.getElementById('searchDropdown');
  const clearBtn = document.getElementById('searchClear');
  const notice   = document.getElementById('searchNotice');
  const cards    = document.querySelectorAll('#productGrid .product-card');

  if (!input) return;

  function renderDropdown(q) {
    const nq = norm(q.trim());
    if (!nq) { dropdown.classList.remove('open'); return; }
    const hits = allSearchProducts.filter(p =>
      norm(p.name).includes(nq) || norm(p.vendor).includes(nq) || norm(p.tierLabel).includes(nq)
    );
    if (!hits.length) {
      dropdown.innerHTML = `<div class="s-empty">Aucun résultat pour <strong>"${q}"</strong></div>`;
    } else {
      dropdown.innerHTML =
        hits.slice(0, 6).map(p => `
          <div class="s-result" data-tier="${p.tier}">
            <div class="s-result-ico">${SVG.search}</div>
            <div class="s-result-body">
              <div class="s-result-name">${hl(p.name, q.trim())}</div>
              <div class="s-result-cat">${p.tierLabel}</div>
            </div>
            <div class="s-result-price">${formatMoney(p.price * 100)}</div>
          </div>`).join('') +
        `<div class="s-foot">${hits.length} résultat${hits.length > 1 ? 's' : ''}</div>`;
      dropdown.querySelectorAll('.s-result').forEach(r =>
        r.addEventListener('click', () => { dropdown.classList.remove('open'); openModal(r.dataset.tier); })
      );
    }
    dropdown.classList.add('open');
  }

  function filterCards(q) {
    const nq = norm(q.trim());
    if (!nq) { cards.forEach(c => c.classList.remove('hidden','lit')); if (notice) notice.classList.remove('on'); return; }
    let found = 0;
    cards.forEach(c => {
      const m = norm(c.dataset.name || '').includes(nq) || norm(c.dataset.category || '').includes(nq);
      c.classList.toggle('hidden', !m); c.classList.toggle('lit', m);
      if (m) found++;
    });
    if (notice) {
      notice.textContent = found ? `${found} produit${found > 1 ? 's' : ''} trouvé${found > 1 ? 's' : ''} pour "${q.trim()}"` : '';
      notice.classList.toggle('on', found > 0);
    }
  }

  input.addEventListener('input', () => {
    clearBtn.style.display = input.value ? 'block' : 'none';
    renderDropdown(input.value); filterCards(input.value);
  });
  input.addEventListener('keydown', e => {
    if (e.key === 'Escape') { dropdown.classList.remove('open'); input.blur(); }
    if (e.key === 'Enter')  { dropdown.classList.remove('open'); filterCards(input.value); }
  });
  clearBtn.addEventListener('click', () => {
    input.value = ''; clearBtn.style.display = 'none';
    dropdown.classList.remove('open'); filterCards(''); input.focus();
  });
  document.addEventListener('click', e => {
    if (!document.getElementById('searchWrap')?.contains(e.target)) dropdown.classList.remove('open');
  });
});

/* ══════════════════════════════════════════════════════
   FAQ
══════════════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item    = btn.closest('.faq-item');
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => { i.classList.remove('open'); i.querySelector('.faq-q')?.setAttribute('aria-expanded','false'); });
      if (!wasOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded','true'); }
    });
  });
});

/* ══════════════════════════════════════════════════════
   RIPPLE
══════════════════════════════════════════════════════ */
const rs = document.createElement('style');
rs.textContent = `@keyframes ripple{from{width:0;height:0;opacity:1}to{width:300px;height:300px;opacity:0}}`;
document.head.appendChild(rs);

function addRipple(root) {
  (root || document).querySelectorAll('.btn-add,.btn-tier,.btn-cart,.mc-btn-add').forEach(b => {
    if (b._ripple) return; b._ripple = true;
    b.addEventListener('click', e => {
      const rect = b.getBoundingClientRect();
      const r    = document.createElement('span');
      Object.assign(r.style, { position:'absolute', borderRadius:'50%', pointerEvents:'none', width:'0', height:'0', backgroundColor:'rgba(255,255,255,.35)', left:(e.clientX-rect.left)+'px', top:(e.clientY-rect.top)+'px', transform:'translate(-50%,-50%)', animation:'ripple .6s ease-out' });
      b.style.position = 'relative'; b.style.overflow = 'hidden';
      b.appendChild(r); setTimeout(() => r.remove(), 600);
    });
  });
}
document.addEventListener('DOMContentLoaded', () => addRipple());
